import getProductFeaturesData from './getProductFeaturesData';
import getPlaybooksGridData from './getPlaybooksGridData';
import getPropositionBlockData from './getPropositionBlockData';

export default function getContentToggleData(props) {
  const data = {};

  data.menu = [];
  props.map((group, index) => {
    const menuItem = {};
    menuItem.label = group.label;
    menuItem.id = group.label.toLowerCase();
    menuItem.toggled = index === 0;
    data.menu.push(menuItem);
    return true;
  });

  data.entries = [];
  props.map((group, index) => {
    data.entries[index] = [];
    group.data.map((entry) => {
      const component = {};
      component.type = entry.sys.contentType.sys.id;
      component.data = false;
      component.data = component.type === 'productFeatures' ? getProductFeaturesData(entry) : component.data;
      component.data = component.type === 'propositions' ? getPropositionBlockData(entry) : component.data;
      component.data = component.type === 'playbooksGrid' ? getPlaybooksGridData(entry) : component.data;
      data.entries[index].push(component);
      return true;
    });
    return true;
  });

  return Object.keys(data).length ? data : false;
}
